import { defineMessage } from 'services/localization';

export const messages = {
    submittedViaXero: defineMessage('created_in_xero'),
    submittedViaQuickBooks: defineMessage('created_in_quickbooks_online'),
    receiptBank: defineMessage('created_in_dext_prepare'),
    netSuite: defineMessage('created_in_oracle_netsuite'),
    dear: defineMessage('created_in_cin_core'),
    submittedBy: defineMessage('submitted_by_username'),
    email: defineMessage('submitted_via_email'),
};
